export default {
  GOOGLEMAPS_PROVIDER: 'google',
  STATIC: 'static'
};
